module.exports = __webpack_public_path__ + "static/media/Pencil.19059b09.svg";